import { ReactNode } from "react";
import { Stack, StackProps, Typography } from "@mui/material";

type PageHeaderProps = {
  title: string;
  children?: ReactNode;
} & StackProps;

export function PageHeader({
  title,
  children,
  ...stackProps
}: PageHeaderProps) {
  return (
    <Stack
      direction={"row"}
      alignItems={"center"}
      paddingInline={2}
      gap={1}
      height={"36px"}
      {...stackProps}
    >
      <Typography variant={"headingLargeRegular"}>{title}</Typography>
      {children}
    </Stack>
  );
}
